import { createSlice } from "@reduxjs/toolkit";
import { ThunkHttpClient } from "../../utils/httpThunkClient";

export const saveOrUpdateBankData = ThunkHttpClient.post('master/saveOrUpdateBankData', 
    (data) => ({ url: "master/saveOrUpdateBankData", body: data }));
export const updateBankDataStatus = ThunkHttpClient.get('master/updateBankDataStatus', 
    (data) => `master/updateBankDataStatus?id=${data.id}&status=${data.status}`);

export const bankAccountSlice = createSlice({
    name: 'bankAccount',
    initialState: {
        bankAccounts: [],
        loading: false
    },
    reducers: {
            
    },
    extraReducers: (builder) => {

        // save or update bank data
        builder.addCase(saveOrUpdateBankData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(saveOrUpdateBankData.rejected, (state) => {
            state.loading = false;
        });
        builder.addCase(saveOrUpdateBankData.fulfilled, (state, action) => {
            state.loading = false;
            state.bankAccounts = action.payload;
        });

    }
})

export default bankAccountSlice.reducer;
